import { ReferenceLine } from 'recharts';
import type { AnnotationMarker } from '../lib/annotations.js';

// recharts clones a ReactElement label with the line's computed viewBox. The
// <title> is what gives the marker a hover tooltip with every change on that
// date; the visible text is only a short handle for it.
export function AnnotationLabel({ viewBox, text, title }: {
  viewBox?: { x?: number; y?: number };
  text: string;
  title: string;
}) {
  const x = (viewBox?.x ?? 0) + 3;
  const y = (viewBox?.y ?? 0) + 10;
  return (
    <g className="annotation-marker-label" style={{ cursor: 'help' }}>
      <title>{title}</title>
      <text x={x} y={y} fontSize={9} fill="var(--loop-neutral-700)">{text}</text>
    </g>
  );
}

/**
 * Dashed vertical lines for chart annotations. A function returning elements
 * rather than a component so each <ReferenceLine> is a direct child of the
 * chart, which is the placement recharts documents. `markers` must already be
 * snapped onto the chart's plotted dates (snapAnnotationMarkers).
 */
export function annotationLines(markers: AnnotationMarker[]) {
  return markers.map(m => (
    <ReferenceLine
      key={`annotation-${m.date}`}
      x={m.date}
      stroke="var(--loop-neutral-500)"
      strokeDasharray="4 3"
      label={<AnnotationLabel text={m.label} title={m.titles.join('\n')} />}
    />
  ));
}
